module.exports = __webpack_public_path__ + "static/img/解决方案-化工行业智能监管解决方案-装卸作业合规监管.90fa6a14.png";